import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { EnumContentType } from '@/constant/enums';

const baseUrl = envConfig.formalServer + '/source/admin/archive/';

function baseApi() {

    function overwrite(data) {
        return Post(baseUrl + 'overwrite', data, {
            headers: {
                'Content-Type': EnumContentType.formData
            }
        });
    }

    return {
        overwrite
    };
}

export const archiveApi = baseApi();
